<template>
  <div class="page-wrap">
    <Header></Header>

    <div class="content">
      <div class="menu">
        <el-tree default-expand-all :data="userList" :props="defaultProps" node-key="name" current-node-key="一、 接口简介" highlight-current  @node-click="handleNodeClick"></el-tree>
      </div>

      <div class="text" v-if="changeData">
        <div class="fz18 mb20 fw">
          <span>{{ changeData.name }}</span>
        </div>
        <div v-html="changeData.content"></div>
      </div>
    </div>

    <Bottom></Bottom>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import {dataInJs} from "@/pages/interfaceDocumentation/data";

export default {
  name: "document",
  components: {Bottom, Header},
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      userList: dataInJs(),
      changeData: null,
    }
  },
  created() {
    this.changeData = this.userList[0]
  },
  methods: {
    handleNodeClick(data) {
      console.log(data);
      if (!data.content){
        return
      }
      this.changeData = data
    }
  }
}
</script>

<style lang="less">
.punctuation{
  width: 9px;
  height: 9px;
  background-color: #000000;
  margin: 10px 10px;
  border-radius: 999px
}

.punctuation-sm{
  width: 5px;
  height: 5px;
  background-color: #000000;
  margin: 11px 10px;
  border-radius: 999px
}

.pic2-1{
  background-image: url('~@/assets/interfaceDocumentation/2.1.png');
  margin-top: 20px;
  margin-bottom: 20px;
}
.pic-fl-1{
  background-image: url('~@/assets/interfaceDocumentation/fl-1.png');
  margin-top: 20px;
  margin-bottom: 20px;
}
.pic-fl-2{
  background-image: url('~@/assets/interfaceDocumentation/fl-2.png');
  margin-top: 20px;
  margin-bottom: 20px;
}
.pic-fl-3{
  background-image: url('~@/assets/interfaceDocumentation/fl-3.png');
  margin-top: 20px;
  margin-bottom: 20px;
}
.pic-fl-4{
  background-image: url('~@/assets/interfaceDocumentation/fl-4.png');
  margin-top: 20px;
  margin-bottom: 20px;
}

tr {
  //border-bottom: 1px solid black; /* 修改颜色和粗细以适应你的需求 */
  border-bottom: 1px solid #e5e5e5
}

th{
  padding: 10px 20px;
}

td{
  padding: 10px 20px;
}

.js-box{
  padding: 18px 24px;
  background-color: #fafafa;
  border: 1px solid #eaeefb;

  .line-1{
    text-indent: 20px
  }

  .line-2{
    text-indent: 40px
  }
}
</style>

<style scoped lang="less">
::v-deep .login-title {
  background-color: #f5f7fa;
}

//::v-deep .el-tree-node__label {
//  color: #07c160;
//}

::v-deep .card-width {
  width: 100%;
  padding: 0 32px;
}

.content{
  height: calc(100vh - 104px);
  min-height: 778px;
  display: flex;

  //background: #f5f7fa;

  .menu{
    position: relative;
    width: 340px;
    padding: 20px 0;
    overflow-y: auto; /* 仅当内容垂直方向超出时显示滚动条 */
    max-height: calc(100vh - 104px); /* 设定最大高度，超出此高度时显示滚动条 */
  }

  .text{
    width: calc(100vw - 340px);
    padding: 20px 30px;
    text-align: left;
    line-height: 30px;
    overflow-y: auto; /* 仅当内容垂直方向超出时显示滚动条 */
    max-height: calc(100vh - 104px); /* 设定最大高度，超出此高度时显示滚动条 */
  }
}
</style>
